import React from 'react';
import RoutesFormatter from '../../components/RoutesFormatter';

const routesFormatter = cell => <RoutesFormatter routes={cell} />;

export default routesFormatter;
